import { IS_PROD } from "./env";

const TRANSLATIONS_HOST = IS_PROD ? "https://api.prod.intranet.auto1.cloud" : "https://api.qa.intranet.auto1.cloud";
export const TRANSLATIONS_API = `${TRANSLATIONS_HOST}/v1/translation/Feedback%20tool`;
export const DEFAULT_LOCALE = "en";
